import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Importation de tes composants
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";


// Importation des pages
import Accueil from "./pages/Accueil";
import Shop from "./pages/Shop";
import Blog from "./pages/Blog";
import Contact from "./pages/Contact";
import Commande from "./pages/Commande";
import Register from "./pages/Register";
import Apropos from "./pages/Apropos";




function App() {
  return (
    <Router>
      {/* Barre de navigation */}
      <Navbar />

      {/* Contenu principal */}
      <main>
        <Routes>
          <Route path="/" element={<Accueil />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/register" element={<Register />} />
          <Route path="/commande" element={<Commande />} />
          <Route path="/apropos" element={<Apropos />} />
        </Routes>
      </main>

      {/* Pied de page */}
      <Footer />
    </Router>
  );
}

export default App;
